// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___2M209","container_1":"container_1___18WNb","container_2":"container_2___1hnXf"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/widget/styles.module.scss
// module id = 246
// module chunks = 0